export default {
	inputValidationRules() {
		return {
			required: value => {
				return value && !!Object.values(value).length || 'Поле обязательно для заполнения';
			},
			positiveNumber: value => {
				return !value || value > 0 || 'Укажите положительное число';
			}
		};
	}
};
